//
//
//
//
//

export default {
    props: ['invasions'],
}
